// extracted by mini-css-extract-plugin
module.exports = {"root":"contentscreens_root__2Fk56"};